<template>
<div>

    <v-card
        style="margin-bottom: 10px;"
    >
        <v-list-item>
            <v-list-item-icon>
                <v-icon>
                    mdi-phone
                </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title class="headline">{{device.label}}</v-list-item-title>
                <v-list-item-subtitle>{{prettyPrintPhone(device.endpoint)}}</v-list-item-subtitle>
                <v-list-item-subtitle v-if="device.accept_sms">Accepts SMS (Text) Messages</v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>

        <v-card-actions
            v-show="can_write"
        >
            <v-spacer/>
            <v-btn
                text
                color="primary"
                v-on:click="onEdit"
            >
                Edit
            </v-btn>
            <v-btn
                text
                color="primary"
                v-on:click="onDelete"
            >
                Delete
            </v-btn>
        </v-card-actions>

    </v-card>
</div>
</template>

<script>
const E164 = require('@/js/E164.js');

export default {
    props: {
        device: {
            type: Object,
            default: function() { return {}; }
        },
        index: {
            type: Number,
            default: function() { return 0; }
        },
        can_write: {
            type: Boolean,
            default: function() { return false; }
        }
    },

    methods: {
        prettyPrintPhone(value)
        {
            return E164.prettyPrintUsPhoneNumber(value);
        },

        onEdit()
        {
            this.$emit('edit',this.index);
        },

        onDelete()
        {
            this.$emit('delete',this.index);
        },
    },
}
</script>

<style lang="scss" scoped>

</style>